module.exports = __webpack_public_path__ + "img/cosmic.1e7822b1.jpg";